"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.mapNumberRangeFieldProperties = exports.onChangeNumberRangeField = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireDefault(require("react"));

var _reactLoadable = _interopRequireDefault(require("react-loadable"));

var _Loader = _interopRequireDefault(require("../../Loader"));

var _Validations = require("../../Validations");

var _FieldMapper = _interopRequireWildcard3(require("./FieldMapper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LoadableNumberRange = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../NumberRange"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});
var LoadableCurrencyRange = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../CurrencyRange"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});

var getValidations = function getValidations(field, minValue, maxValue) {
  var validations = [];
  validations.push(_Validations.numberRangeBoundryValidation);

  if (field.properties.isRequired) {
    validations.push(_Validations.rangeRequiredValidation);
  }

  if (minValue) {
    validations.push(_Validations.numberRangeMinValue);
  }

  if (maxValue) {
    validations.push(_Validations.numberRangeMaxValue);
  }

  return validations;
};

var mapInputProperties = function mapInputProperties(field, model) {
  var minValue, maxValue;
  minValue = parseFloat(field.properties.minValue);
  maxValue = parseFloat(field.properties.maxValue);
  minValue = isNaN(minValue) ? undefined : minValue;
  maxValue = isNaN(maxValue) ? undefined : maxValue;
  return _objectSpread(_objectSpread({}, model), {}, {
    component: LoadableNumberRange,
    fromProps: {
      label: "From",
      placeholder: field.properties.placeholderFrom
    },
    toProps: {
      label: "To",
      placeholder: field.properties.placeholderTo
    },
    minValue: minValue,
    maxValue: maxValue,
    onChange: onChangeNumberRangeField,
    validations: getValidations(field, minValue, maxValue),
    onlyValidateOnBlur: true
  });
};

var mapMaskedRangeInputProperties = function mapMaskedRangeInputProperties(field, model) {
  return _objectSpread(_objectSpread({}, mapInputProperties(field, model)), {}, {
    component: LoadableCurrencyRange,
    onlyValidateOnBlur: true
  });
};

var onChangeNumberRangeField = function onChangeNumberRangeField(params) {
  var value = params[1];
  var range = {
    display: {},
    value: {}
  };

  if (value) {
    range.display = {
      to: value.to,
      from: value.from
    };
    var fromParsed = parseFloat(value.from);
    var toParsed = parseFloat(value.to);
    range.value.valueFrom = isNaN(fromParsed) ? "" : fromParsed;
    range.value.valueTo = isNaN(toParsed) ? "" : toParsed;
  }

  return range;
};

exports.onChangeNumberRangeField = onChangeNumberRangeField;

var mapNumberRangeFieldProperties = function mapNumberRangeFieldProperties(_ref) {
  var field = _ref.field,
      htmlId = _ref.htmlId,
      display = _ref.display,
      value = _ref.value,
      onValidation = _ref.onValidation;
  var displayValue = display;

  if (!displayValue) {
    if (value) {
      var from = value.valueFrom;
      var to = value.valueTo;
      displayValue = {
        from: !from ? "" : from.toString(),
        to: !to ? "" : to.toString()
      };
    } else {
      displayValue = {
        from: "",
        to: ""
      };
    }
  }

  var model = (0, _FieldMapper.default)(field, htmlId, displayValue, undefined, onValidation);

  switch (field.properties.editor) {
    case "MaskedInput":
      return mapMaskedRangeInputProperties(field, model);

    default:
      return mapInputProperties(field, model);
  }
};

exports.mapNumberRangeFieldProperties = mapNumberRangeFieldProperties;
var _default = mapNumberRangeFieldProperties;
exports.default = _default;